{
  "app_name": "金数据客户端",
  "ios": {
    "CFBundleDisplayName": "金数据"
  }
}
